import type { SecondaryButtonProps } from "@sb1/ffe-buttons-react";
import { SecondaryButton as FellesSecondaryButton } from "@sb1f/buttons";
import { getCustomData } from "~/utils/tracking/utils";

type Props = SecondaryButtonProps & {
	track?: boolean;
	knappNavn?: string;
	trackingData?: object;
};

const SecondaryButton = ({ track = true, trackingData, ...props }: Props) => {
	const customData = trackingData ? { ...trackingData, ...getCustomData() } : getCustomData();
	return <FellesSecondaryButton customData={customData} {...props} />;
};

export default SecondaryButton;
